import React, { useEffect } from "react";
import online from "../../../images/landingPage/online.svg";
import AppBody from "../../components/AppBody";
import { useDispatch, useSelector } from "react-redux";
import { getAssignUserCoureseList } from "../../../actions/course/assign_course/assign_course_action";
import { useNavigate } from "react-router-dom";
const ViewCouesesToUser = () => {
  const dispatch = useDispatch("");
  const state = useSelector((state) => state.assignCourseReducer);
  useEffect(() => {
    dispatch(getAssignUserCoureseList());
  }, []);

  const navigate = useNavigate();

  const handelStartCourse = (slug) => {
    navigate("/course/" + slug);
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <h4 className="font-xs text-white fw-600 mb-0 mt-2">Courses</h4>
              </div>
              <div className="card-body p-4 w-100 border-0 ">
                <div className="row">
                  <div className="col-md-3 usr-course-div">
                    <select className="form-control usr-course-search">
                      <option>All</option>
                      <option>Courses </option>
                    </select>
                  </div>
                  <div className="col-md-8 usr-course-div">
                    <input
                      type="text"
                      placeholder="Search Course"
                      className="form-control usr-course-search"
                    />
                    <br />
                    <br />
                  </div>
                </div>
                <div className="row cource-section">
                  <div className="col-12 usr-course-div">
                   <h1>Assigned Courses</h1>
                  </div>
                  {state.toDoCoursesList &&
                    state.toDoCoursesList.map((li, i) => (
                      <div className="col-lg-4 mb-3">
                        <div className="box">
                          <div className="row">
                            <div className="col-xs-12 col-12">
                              <h4 className="title certification-nm">
                                <span className="certification-nm">
                                  {li.name}
                                </span>
                              </h4>
                              {/*<p className="course-count">10+ Courses</p>*/}
                            </div>
                            <br />
                            <div className="col-xs-6 col-6">
                              <h6 className="cer-details"></h6>
                              <h6 className="cer-details">{"Assign Date"}</h6>
                              <h6 className="cer-details">{li.start_date}</h6>
                            </div>

                            <div className="col-xs-6 col-6 align-c">
                              <h6 className="cer-details">{"End Date"}</h6>
                              <h6 className="cer-details">{li.end_date}</h6>
                            </div>
                            <div className="col-7">60% Completed</div>
                            <div className="col-5">
                              <button
                                className="btn-common"
                                onClick={() => handelStartCourse(li.slug)}
                              >
                                <i className="fa fa-play"></i> Play
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                <div className="row cource-section">
                  <div className="col-12 usr-course-div">
                    <h1>Completed Courses</h1>
                  </div>
                  {state.toDoCoursesList &&
                    state.toDoCoursesList.map((li, i) => (
                      <div className="col-lg-4 mb-3">
                        <div className="box">
                          <div className="row">
                            <div className="col-xs-12 col-12">
                              <h4 className="title certification-nm">
                                <span className="certification-nm">
                                  {li.name}
                                </span>
                              </h4>
                              {/*<p className="course-count">10+ Courses</p>*/}
                            </div>
                            <br />
                            <div className="col-xs-6 col-6">
                              <h6 className="cer-details"></h6>
                              <h6 className="cer-details">{"Assign Date"}</h6>
                              <h6 className="cer-details">{li.start_date}</h6>
                            </div>

                            <div className="col-xs-6 col-6 align-c">
                              <h6 className="cer-details">{"End Date"}</h6>
                              <h6 className="cer-details">{li.end_date}</h6>
                            </div>
                            <div className="col-7">100% Completed</div>
                            <div className="col-5">
                              <button
                                className="btn-common"
                                onClick={() => handelStartCourse(li.slug)}
                              >
                                <i className="fa fa-play"></i> Play
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                <div className="row cource-section">
                  <div className="col-12 usr-course-div">
                    <h1>Enrolled Courses</h1>
                  </div>

                  <div className="col-lg-4 mb-3">
                    <div className="box">
                      <div className="row">
                        <div className="col-xs-12 col-12">
                          <h4 className="title certification-nm">
                            <span className="certification-nm">
                              {"Python"}
                            </span>
                          </h4>
                          {/*<p className="course-count">10+ Courses</p>*/}
                        </div>
                        <br />
                        <div className="col-xs-6 col-6">
                          <h6 className="cer-details">Category</h6>
                          <h6 className="cer-details">{"Beginner"}</h6>
                          <h6 className="cer-details">{"24/08/2023"}</h6>
                        </div>

                        <div className="col-xs-6 col-6 align-c">
                          <img className="" src={online} alt="First slide" />
                        </div>
                        <div className="col-5"></div>
                        <div className="col-7  align-r">
                          <a className="mr-14">Course Content</a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 mb-3">
                    <div className="box">
                      <div className="row">
                        <div className="col-xs-12 col-12">
                          <h4 className="title certification-nm">
                            <span className="certification-nm">
                              {"FullStack Development"}
                            </span>
                          </h4>
                          {/*<p className="course-count">10+ Courses</p>*/}
                        </div>
                        <br />
                        <div className="col-xs-6 col-6">
                          <h6 className="cer-details">Category</h6>
                          <h6 className="cer-details">{"Beginner"}</h6>
                          <h6 className="cer-details">{"24/08/2023"}</h6>
                        </div>

                        <div className="col-xs-6 col-6 align-c">
                          <img className="" src={online} alt="First slide" />
                        </div>

                        <div className="col-5"></div>
                        <div className="col-7  align-r">
                          <a className="mr-14">Course Content</a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 mb-3">
                    <div className="box">
                      <div className="row">
                        <div className="col-xs-12 col-12">
                          <h4 className="title certification-nm">
                            <span className="certification-nm">
                              {"Google Cloud"}
                            </span>
                          </h4>
                          {/*<p className="course-count">10+ Courses</p>*/}
                        </div>
                        <br />
                        <div className="col-xs-6 col-6">
                          <h6 className="cer-details">Category</h6>
                          <h6 className="cer-details">{"Beginner"}</h6>
                          <h6 className="cer-details">{"24/08/2023"}</h6>
                        </div>

                        <div className="col-xs-6 col-6 align-c">
                          <img className="" src={online} alt="First slide" />
                        </div>

                        <div className="col-5"></div>
                        <div className="col-7  align-r">
                          <a className="mr-14">Course Content</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ViewCouesesToUser;
